import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../shared/environments/environment';
import { Observable, share } from 'rxjs';
import { Params } from '@angular/router';
import { IPaginatedResponse } from '../typing/response.interface';
import { ICompany, ICompanyCreate, ICompanyUpdate } from '../typing/company.interface';

@Injectable({
    providedIn: 'root'
})
export class CompanyService {

    constructor(private http: HttpClient) {
    }

    getCompanies(query: Params): Observable<IPaginatedResponse<ICompany>> {
        return this.http.get<IPaginatedResponse<ICompany>>(`${environment.API_BASE_PATH}/companies`, {params: query});
    }

    getCompany(id: number): Observable<ICompany> {
        return this.http.get<ICompany>(`${environment.API_BASE_PATH}/company/${id}`).pipe(share());
    }

    updateCompany(company: ICompanyUpdate): Observable<ICompany> {
        return this.http.put<ICompany>(`${environment.API_BASE_PATH}/company/${company.id}`, company);
    }

    createCompany(company: ICompanyCreate): Observable<ICompany> {
        return this.http.post<ICompany>(`${environment.API_BASE_PATH}/company`, company);
    }

    deleteCompanies(companyIds: number[]): Observable<void> {
        return this.http.delete<void>(`${environment.API_BASE_PATH}/companies`, {
            body: companyIds
        });
    }
}
